(function () {
  function initSizeGuide(root) {
    var openBtn = document.querySelector('[data-size-guide-open]');
    var closeEls = root.querySelectorAll('[data-size-guide-close]');
    if (!openBtn) return;

    function open() {
      root.setAttribute('data-open', '');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      root.removeAttribute('data-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.hasAttribute('data-open')) close();
    });
  }

  document.querySelectorAll('[data-size-guide]').forEach(initSizeGuide);
})();
